import { render, staticRenderFns } from "./Profile1.vue?vue&type=template&id=980c4968&scoped=true"
import script from "./Profile1.vue?vue&type=script&lang=js"
export * from "./Profile1.vue?vue&type=script&lang=js"
import style0 from "./Profile1.vue?vue&type=style&index=0&id=980c4968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980c4968",
  null
  
)

export default component.exports